import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sample-comp',
  templateUrl: './sample-comp.component.html',
  styleUrls: ['./sample-comp.component.scss']
})
export class SampleCompComponent {

  @Input() isOpen: boolean = false;
  @Input() data: any;
  @Input() sideMenuItem: any;
  @Output() close = new EventEmitter<void>();

  closeSidebar(): void {
     this.close.emit();
  }

  constructor(){
    console.log("oninit is called");
    
  }
}
